import React from 'react';
import { store } from './redux-store';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from "react-router-dom";
import { Route, Switch, Redirect } from "react-router-dom";

import {
  Cart,
  Home,
  Login,
  Details,
  Products,
  Checkout,
  ERROR404,
  Fulfillment
} from "views";

const Routes = () => (
  <Switch>

    <Route exact path='/home' component={Home}/>

    <Route exact path='/cart' component={Cart}/>

    <Route exact path='/login' component={Login}/>

    <Route exact path='/signup' render={(props) => <Login signup {...props}/>}/>

    <Route exact path='/'><Redirect to='/home'/></Route>

    <Route exact path='/checkout' component={Checkout}/>

    <Route exact path='/payment/:id' component={Fulfillment}/>

    <Route exact path='/products/:category' component={Products}/>

    <Route exact path='/products/:category/:handle' component={Details}/>

    <Route component={ERROR404}/>

  </Switch>
);

export default () => (
  <Provider store={store}>
    <Router onUpdate={() => window.scrollTo(0, 0)}>
      <Routes/>
    </Router>
  </Provider>
);
